export default "__VITE_ASSET__BHVKAX44__"